<template>
  <autocomplete
    v-model="selectedCompanyProxy"
    :items="mealCompanies"
    dense
    filled
    :label="$t('select_company')"
    item-text="name"
    item-value="id"
    return-object
    clear
    chips
    small-chips
    :loading="loading.fetchMealCompanies"
    :disabled="loading.fetchMealCompanies"
  />
</template>

<script>
export default {
  name: "ReportFieldSelectFoodCompany",
  data() {
    return {
      loading: {
        fetchMealCompanies: false,
      },
    };
  },
  computed: {
    selectedCompany: {
      get() {
        return this.$store.state.report.selectedMealCompany;
      },
      set(val) {
        this.$store.commit("report/SET_SELECTED_MEAL_COMPANY", val);
      },
    },
    selectedCompanyProxy: {
      get() {
        return this.selectedCompany;
      },
      set(val) {
        this.selectedCompany = val;
      },
    },
    filters() {
      return this.$store.state.report.filters;
    },
    mealCompanies() {
      return this.$store.state.report.mealCompanies.map((company) => ({
        ...company,
        company: this.toLatin(company.company),
      }));
    },
    restaurantId() {
      return this.$store.state.restaurant.id;
    },
  },
  watch: {
    restaurantId: {
      async handler(newVal) {
        if (this.loading.fetchMealCompanies) {
          console.warn(
            "Fetch meal companies operation already in progress, skipping duplicate request"
          );
          return;
        }

        if (!newVal) return;

        this.loading.fetchMealCompanies = true;

        try {
          await this.$store.dispatch("report/fetchMealCompanies", {
            date_from: this.filters.dates.from,
            date_to: this.filters.dates.to,
            restaurant_id: newVal,
          });

          if (this.mealCompanies && this.mealCompanies.length) {
            this.selectedCompanies = [this.mealCompanies[0]];
          }
        } catch (error) {
          console.error("Error fetching meal companies:", error);
        } finally {
          this.loading.fetchMealCompanies = false;
        }
      },
      immediate: true,
    },
  },
};
</script>
